// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3216G","colMin":"styles_colMin__2j1rm","colCheckbox":"styles_colCheckbox__3LAEA"};